import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { _ } from "../../functions/translator";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { dayChange, filterChange } from "../../actions";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import { FilterActions } from "../../constants/constants";

const DayTimeCalendar = (props) => {
  const [firstDate, setFirstDate] = useState(props.day.first);
  const [lastDate, setLastDate] = useState(props.day.last);
  const [selectedRange, setSelectedRange] = useState('personalized');
  const firstDatePickerRef = useRef();
  const secondDatePickerRef = useRef();

  const useStyles = makeStyles((theme) => ({
      selected: {
        backgroundColor: '#3f51b5 !important',
        color: 'white',
      },
    }));
  const classes = useStyles();

  useEffect(() => {
    setFirstDate(props.day.first)
    setLastDate(props.day.last)
  }, [props.day])

  const handleFirstChange = (event) => {
    const date = new Date(event.target.value).toISOString().split('T')[0];
    setFirstDate(date);
    props.dayChange({ ...props.day, first: date });
    props.filterChange(FilterActions.DATE_RANGE, 'personalized');
    setSelectedRange('personalized');
  };

  const handleLastChange = (event) => {
    const date = new Date(event.target.value).toISOString().split('T')[0];
    setLastDate(date);
    props.dayChange({ ...props.day, last: date });
    props.filterChange(FilterActions.DATE_RANGE, 'personalized');
    setSelectedRange('personalized');
  };

  const applyDateRange = (range) => {
    props.filterChange(FilterActions.DATE_RANGE, range);
    const today = new Date();
    let start, end;

    switch (range) {
      case "historical":
        start = props.projectData.days[0].id;
        end = props.projectData.days[props.projectData.days.length - 1].id;
        break;
      case "last_month":
        const firstDayPrevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastDayPrevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        start = firstDayPrevMonth.toISOString().split('T')[0];
        end = lastDayPrevMonth.toISOString().split('T')[0];
        break;
      case "this_month":
        start = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
        end = today.toISOString().split('T')[0];
        break;
      case "this_week":
        const currentDay = today.getDay();
        const diffToMonday = (currentDay + 6) % 7;
        const monday = new Date(today);
        monday.setDate(today.getDate() - diffToMonday);
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        start = monday.toISOString().split('T')[0];
        end = sunday.toISOString().split('T')[0];
        break;
      case "last_7_days":
        start = new Date(today.setDate(today.getDate() - 6)).toISOString().split('T')[0];
        end = new Date().toISOString().split('T')[0];
        break;
      case "yesterday":
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        start = end = yesterday.toISOString().split('T')[0];
        break;
      case "today":
        start = end = new Date().toISOString().split('T')[0];
        break;
      case "personalized":
        start = end = new Date().toISOString().split('T')[0];
        break;
      case "last_30_days":
        start = new Date(today.setDate(today.getDate() - 29)).toISOString().split('T')[0];
        end = new Date().toISOString().split('T')[0];
        break;
      case "last_90_days":
        start = new Date(today.setDate(today.getDate() - 89)).toISOString().split('T')[0];
        end = new Date().toISOString().split('T')[0];
        break;
      default:
        return;
    }

    setFirstDate(start);
    setLastDate(end);
    props.dayChange({ ...props.day, first: start, last: end });
    setSelectedRange(range);
  };
  const minDate = props.projectData.days[0].id;

  return (
    <div className="w-100 d-flex flex-column">
      <div className="ml-2">
        <p className="mt-2 mb-1 timefilter-label">{_('Rango de fechas')}:</p>
        <Select
            style={{width: '97%'}}
            name="input_type"
            value={selectedRange}
            onChange={(e) => applyDateRange(e.target.value)}
            MenuProps={{
                MenuListProps: {
                    disablePadding: true,
                },
                classes: {
                    paper: classes.paper,
                },
                }}
            >
            <MenuItem value={'personalized'}>
                <p className='m-0'>{_('Fecha personalizable')}</p>
            </MenuItem>
            <MenuItem value={'today'}>
                <p className='m-0'>{_('Hoy')}</p>
            </MenuItem>
            <MenuItem value={'yesterday'}>
                <p className='m-0'>{_('Ayer')}</p>
            </MenuItem>
            <MenuItem value={'this_week'}>
                <p className='m-0'>{_('Esta semana')}</p>
            </MenuItem>
            <MenuItem value={'last_7_days'}>
                <p className='m-0'>{_('Últimos 7 días')}</p>
            </MenuItem>
            <MenuItem value={'this_month'}>
                <p className='m-0'>{_('Este mes')}</p>
            </MenuItem>
            <MenuItem value={'last_30_days'}>
                <p className='m-0'>{_('Últimos 30 días')}</p>
            </MenuItem>
            <MenuItem value={'last_month'}>
                <p className='m-0'>{_('Mes anterior')}</p>
            </MenuItem>
            <MenuItem value={'last_90_days'}>
                <p className='m-0'>{_('Últimos 90 días')}</p>
            </MenuItem>
            <MenuItem value={'historical'}>
                <p className='m-0'>{_('Histórico')}</p>
            </MenuItem>
        </Select>
      </div>

      <div style={{width: '94%'}} className="d-flex flex-row">
        <div className="ml-2 w-50 pr-1">
          <p className="mb-1 timefilter-label">{_('Desde')}:</p>
          <TextField
            type="date"
            ref={firstDatePickerRef}
            value={firstDate}
            onChange={(date) => handleFirstChange(date)}
            variant='outlined'
            inputProps={{
              min: minDate,
            }}
            InputLabelProps={{
              shrink: true
            }}
            sx={{ margin: 0 }}
            className="w-100 p-0"
            style={{ fontSize: '12px' }}
          />
        </div>

        <div className="w-50 pl-1">
          <p className="mb-1 timefilter-label">{_('Hasta')}:</p>
          <TextField
            type="date"
            ref={secondDatePickerRef}
            value={lastDate}
            onChange={(date) => handleLastChange(date)}
            variant='outlined'
            inputProps={{
              min: minDate,
            }}
            InputLabelProps={{
              shrink: true
            }}
            sx={{ margin: 0 }}
            className="w-100 p-0"
            style={{ fontSize: '12px' }}
          />
        </div>
      </div>
    </div>

      
  );
};

function mapStateToProps(state) {
  return {
    day: state.day,
    projectData: state.projectData
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    dayChange: dayChange,
    filterChange: filterChange,
  }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(DayTimeCalendar);
